export { TournamentsTab } from "./TournamentsTab";
export { SuperprizeTab } from "./SuperprizeTab";
export { RulesTab } from "./RulesTab";